import { openNewTab } from '../helpers';

export default function planVisitBtn() {
  const widgetName = 'planVisitBtn';
  const widgetOpts = planVisitBtnOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomTicketBtn(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      $widget.remove();
      $('body').addClass(`${widgetName}-no-data`);
    } else {
      const targetElement = openNewTab(URL);
      $widget.replaceWith(
        `<a class="plan-btn" tabindex="0" href="${URL}" ${targetElement}>${Title}</a>`,
      );
    }
  }
}
